module.exports = __webpack_public_path__ + "3ae064138b80ba556f2d6ac6181bf2bb.svg";